import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
  created() {
    let itemsString = [`id=${uuidv4()}`, `referrer=${encodeURIComponent(window.location.href)}`];

    for (let objK of Object.keys(this.$route.query)) {
      itemsString.push(`${objK}=${this.$route.query[objK]}`);
    }

    this.$data.queryStringForSubForm = itemsString.join('&');
  }
})

export default class BetterStartForm extends Vue {
  queryStringForSubForm: string = null;
}
